import React, { Fragment } from 'react'
import styles from './styles.module.css'
import states_and_lga from './statesLga'

export const Select = (props) => {
  const stateList = Object.keys(states_and_lga).map((key) => ({
    name: key
  }))

  return (
    <Fragment>
      <div className={styles['form-group']}>
        <label>State</label>
        <select
          name='states_of_nigeria'
          id='states_of_nigeria'
          value={props.state}
          onChange={props.changeState}
        >
          <option value=''>Select state</option>
          {stateList.map((state, key) => (
            <option key={key} value={state.name}>
              {state.name}
            </option>
          ))}
        </select>
      </div>

      <div className={styles['form-group']}>
        <label>Local Government</label>
        <select onChange={props.changeLga} value={props.lga}>
          <option>Select LGA</option>
          {props.state === ''
            ? ''
            : states_and_lga[props.state].map((lga, key) => (
                <option key={key} value={lga}>
                  {lga}
                </option>
              ))}
        </select>
      </div>
    </Fragment>
  )
}
